import { useQuery } from "@tanstack/react-query";
import { TechnologyDictionaryModel } from "../../models/technology.model";
import { technologyDictionaryService } from "../../services/dictionaries";

export const useTechnologiesDictionary = () => {
  return useQuery({
    queryKey: ["technologies", "dictionary"],
    queryFn: async (): Promise<TechnologyDictionaryModel[]> => {
      return technologyDictionaryService.getTechnologiesDictionary();
    },
    staleTime: 1000 * 60 * 15, // 15 minutes - dictionary data doesn't change often
    gcTime: 1000 * 60 * 30, // 30 minutes
  });
};
